import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "../../auth/auth.service";
import { environment } from "../../../environments/environment";
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  @Input() public pullDown: boolean = true;
  public _version: string = environment.version;
  public _copyright: string;

  constructor(public authSrv: AuthService, public translate: TranslateService) {
    
  }
  
  ngOnInit() {
    const self = this;
    this._copyright = this.translate.instant("4").replace("$YEAR", (new Date()).getFullYear());
    //TODO: lorsqu'on change la langue le copyright se met à jour
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this._copyright = this.translate.instant("4").replace("$YEAR", (new Date()).getFullYear());
    });
  }
}
